import { render, staticRenderFns } from "./PushNotificationMessages.vue?vue&type=template&id=2113d602&"
import script from "./PushNotificationMessages.vue?vue&type=script&lang=js&"
export * from "./PushNotificationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports